import React from 'react';
import { Upload } from 'lucide-react';
import { useDropzone } from 'react-dropzone';

interface DropZoneProps {
  onDrop: (acceptedFiles: File[]) => void;
}

export const DropZone: React.FC<DropZoneProps> = ({ onDrop }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/webp': [],
    },
    multiple: true,
  });

  return (
    <div
      {...getRootProps()}
      className={`dropzone ${isDragActive ? 'active' : ''}`}
    >
      <input {...getInputProps()} />
      <div className="flex flex-col items-center gap-4">
        <Upload className="w-12 h-12 text-sage-400" />
        <div className="space-y-2">
          <p className="text-lg font-medium text-sage-700">
            {isDragActive ? 'Drop images here' : 'Drag & drop product images'}
          </p>
          <p className="text-sm text-sage-500">
            Upload up to 50 images (JPEG, PNG, WebP up to 5MB each)
          </p>
        </div>
      </div>
    </div>
  );
};